import { render, staticRenderFns } from "./InterestDropdown.vue?vue&type=template&id=64df3710&"
import script from "./InterestDropdown.vue?vue&type=script&lang=js&"
export * from "./InterestDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports